// hooks
import { useDropzone } from "react-dropzone";

// assets
import { ReactComponent as ImportIcon } from '../../../assets/Icons/adornments/Import.svg';

export type MIMEFileTypes = 'csv' | 'sdf' | 'xlsx';

export default function DragAndDropRawFile({
    onDrop
}: {
    onDrop: (acceptedFiles: File[]) => void
}) {

      const {getRootProps, getInputProps, open} = useDropzone({
        accept: {
            'text/csv': ['.csv'],
            'chemical/x-mdl-sdf': ['.sdf'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
        },
        maxFiles: 1,
        onDrop,
      });
      
    
      return (
        <div className="w-full flex flex-col justify-center items-start gap-2 text-default">
            <label className={`text-[12px] font-medium required`}>Upload Raw Data File</label>
            <div className='hover:cursor-pointer hover:border-primary hover:bg-secondary hover:bg-opacity-[0.3] transition-all w-full bg-white rounded-lg flex justify-center items-center p-8 border border-dashed border-quaternary' {...getRootProps()}>
              <input data-testid='dropzone' {...getInputProps()} />
                  <div className='flex flex-col justify-center items-center gap-4'>
                    <div className="w-[32px] h-[32px] text-primary"><ImportIcon/></div>
                    <div className="flex flex-col gap-1">
                      <p className="text-default text-[16px] font-medium leading-[0.9]">Drop file or browse</p>
                      <p className="text-[14px] text-disable">Format: .csv, .xlsx, .sdf</p>
                    </div>
                    {/* <button onClick={open} className="bg-primary hover:brightness-90 transition-all text-white font-semibold text-[14px] py-1 px-4 rounded-lg">Browse Files</button> */}
                  </div>
            </div>
        </div>
      )
}